
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { StepperStep } from './DialogStepper.vue';
import FormItem, { StepItem } from './FormItem.vue';

type FormStep = StepperStep & { items?: StepItem[]; itemsKey?: () => string };

@Component({ components: { FormItem } })
export default class extends Vue {
  @Model('change', { type: Object }) model!: HashAny;

  @Prop() readonly step!: FormStep;

  getStepItems(step: FormStep): StepItem[] {
    if (step.items) {
      return step.items;
    }
    if (typeof step.itemsKey === 'function') {
      const key = step.itemsKey();
      const items: unknown = step[key];
      if (Array.isArray(items)) {
        return items as StepItem[];
      }
    }
    return [];
  }

  showSeparator(item: StepItem, step: FormStep) {
    return (item.separator == null ? step.separator : item.separator) !== false;
  }
}
